module.exports = __webpack_public_path__ + "static/media/gallery25.b9cf8cfe.png";